import React from "react";
import PropTypes from "prop-types";

import ScriptLoader from "components/ScriptLoader";

class YandexMapsScriptLoader extends React.Component {
    render() {
        const key = `13051409-0956-4f3f-acda-51a840dd2d36`; // TODO: Поменять ключ
        const url = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${key}`;

        return <ScriptLoader url={url}>{this.props.children}</ScriptLoader>;
    }
}

YandexMapsScriptLoader.propTypes = {
    children: PropTypes.node
};

export default YandexMapsScriptLoader;
